import { Modal } from "antd";

interface ConfirmSecretRevealOptions {
  okText?: string;
  cancelText?: string;
}

export function confirmSecretReveal(options?: ConfirmSecretRevealOptions): Promise<boolean> {
  return new Promise((resolve) => {
    Modal.confirm({
      title: "Reveal Secret Values",
      content: "Revealing secrets will generate an audit trail log for each secret. Do you want to continue?",
      okText: options?.okText ?? "Reveal",
      cancelText: options?.cancelText ?? "Cancel",
      onOk: () => resolve(true),
      onCancel: () => resolve(false),
    });
  });
}
